/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SearchChatRequestCurrentFilters } from './searchChatRequestCurrentFilters';

export interface SearchChatRequest {
  /** @maxLength 20000 */
  message: string;
  current_filters?: SearchChatRequestCurrentFilters;
}
